import {
  IExperienceMessageDenormalized,
  ITaskDenormalized
} from '@dadohr/shared/domainTypes/experience';
import { groupBy } from 'lodash';
import { useMemo } from 'react';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { MessageCard } from '../Messages';
import { TaskCard } from '../Tasks';

export const TasksAndMessages = ({
  actorAccessToken,
  instanceAccessToken,
  returnTo,
  ds,
  archiveControls
}: {
  actorAccessToken: string;
  instanceAccessToken: string;
  returnTo?: string;
  ds: (
    | {
        type: 'TASK';
        item: ITaskDenormalized;
      }
    | {
        type: 'MSG';
        item: IExperienceMessageDenormalized;
      }
  )[];
  archiveControls?: boolean;
}) => {
  const batches = useMemo(
    () =>
      groupBy(ds, (d) =>
        d.type === 'TASK'
          ? (d.item.start?.toMillis() || 0)
          : (d.item.sendAt?.toMillis() || 0)
      ),
    [ds]
  );
  return (
    <FlexContainerVertical fullWidth spacing={4}>
      {Object.entries(batches).map(([key, items]) => {
        return (
          <FlexContainerVertical fullWidth spacing={1} key={key}>
            {items.map((x) =>
              x.type === 'TASK' ? (
                <TaskCard
                  key={x.item.id}
                  d={x.item}
                  actorAccessToken={actorAccessToken}
                  instanceAccessToken={instanceAccessToken}
                  returnTo={returnTo}
                />
              ) : (
                <MessageCard
                  key={x.item.templateId}
                  d={x.item}
                  instanceAccessToken={instanceAccessToken}
                  archiveControls={archiveControls}
                />
              )
            )}
          </FlexContainerVertical>
        );
      })}
    </FlexContainerVertical>
  );
};
